import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginWithGoogle } from '../lib/firebase';

export function LoginPage() {
  const location = useLocation();
  // Motivo enviado pelo ProtectedLayout quando ele nos devolve para cá.
  const bounceReason = (location.state as { error?: string } | null)?.error || '';

  const [error, setError] = useState(bounceReason);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleLogin() {
    setLoading(true);
    setError('');
    try {
      await loginWithGoogle();
      navigate('/');
    } catch (e) {
      const raw = e instanceof Error ? e.message : '';
      // Fechar o popup é o "erro" mais comum e não merece alarme.
      if (/popup-closed-by-user|cancelled-popup-request/i.test(raw)) {
        setError('');
      } else if (/popup-blocked/i.test(raw)) {
        setError('O navegador bloqueou a janela de login. Libere popups para este site.');
      } else {
        setError(raw || 'Falha no login');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-box">
        <img
          src="/icons/icon-192.png"
          alt="NextBoost"
          width={72}
          height={72}
          className="brand-mark"
        />
        <h1>NEXT<span style={{ color: 'var(--accent)' }}>BOOST</span> Console</h1>
        <p className="muted" style={{ marginBottom: 24 }}>
          Plataforma operacional na VPS — acesso restrito a contas administrativas.
        </p>
        <button
          type="button"
          onClick={handleLogin}
          disabled={loading}
          style={{ width: '100%', padding: '13px', fontSize: 15 }}
        >
          {loading ? (
            <span className="row" style={{ justifyContent: 'center', gap: 9 }}>
              <span className="spinner" style={{ width: 15, height: 15 }} />
              Entrando…
            </span>
          ) : (
            'Entrar com Google'
          )}
        </button>
        {error && <p className="alert error" style={{ marginTop: 16, marginBottom: 0 }}>{error}</p>}
      </div>
    </div>
  );
}
